<script lang="ts">
    import {getLocalization} from 'src/core';
    import {get} from 'svelte/store';
    import {exists} from 'shared/utils/custom-utils';
    import {callCommand} from '@milkdown/utils';
    import {getRichtextAreaContext} from '../../richtext-area.context';
    import {createCodeBlockCommand} from '@milkdown/preset-commonmark';
    import ToolbarButton from './ToolbarButton.svelte';

    const {editor$} = getRichtextAreaContext();
    const localize = getLocalization();

    function wrapInCode() {
        const editor = get(editor$);
        if (!exists(editor)) {
            return;
        }

        editor.action(
            callCommand(createCodeBlockCommand.key)
        );
    }
</script>

<ToolbarButton icon="code-simple"
               tooltipLabel={localize(/* @kp-localization richTextArea.tools.code */ 'richTextArea.tools.code')}
               on:click={wrapInCode}/>